export enum MonthlySheetStatus {
  reviewFrontline = 'review_frontline',
  approvedFrontline = 'approved_frontline',
  rejectedFrontline = 'rejected_frontline',
  markedChangeNextMonth = 'marked_change_next_month',
  markedChangeThisMonth = 'marked_change_this_month',
}
